import * as yup from 'yup';

import { endpoint, EndpointError } from 'endpoints/endpoint';

import { ERROR as VALIDATION_ERROR } from '../validation';

export type DeleteRoomParams = { roomId: string };
export type DeleteRoomResult = { data: 'OK' };
export type DeleteRoomError = EndpointError;

export const deleteRoom = endpoint<DeleteRoomParams, DeleteRoomResult, DeleteRoomError>({
  method: 'POST',
  url: () => '/live-kit/delete-room',
});

export const deleteRoomParamsSchema: yup.SchemaOf<DeleteRoomParams> = yup.object().shape({
  roomId: yup.string().required(VALIDATION_ERROR.REQUIRED),
});
